// Code generated by apic; DO NOT EDIT.
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, type ChangeEvent } from "react";
import { setApiToken } from "../react/auth";

/**
 * TokenBar renders a bearer-token input field.
 *
 * On every change the value is written through to setApiToken (the ambient
 * module-level bearer-token holder consumed by useExplorerClient).  The
 * optional onChange callback fires afterwards with the new value so callers
 * can react to token changes (e.g. re-render a status chip).
 *
 * Props:
 *   onChange  – optional callback fired with the new token string (or null when
 *               the field is cleared).
 *   className – extra CSS class appended to the root element.
 *
 * Security: the input value is never rendered back as visible text (type="password").
 * No web-global dependencies at module load time (RN-safe).
 */
export function TokenBar(props: {
  onChange?: (t: string | null) => void;
  className?: string;
}): JSX.Element {
  const { onChange, className } = props;
  const [hasToken, setHasToken] = useState<boolean>(false);

  const root = ["apic-ui-token-bar", className].filter(Boolean).join(" ");

  function handleChange(e: ChangeEvent<HTMLInputElement>): void {
    const val = e.target.value;
    const token: string | null = val.length > 0 ? val : null;
    setApiToken(token);
    setHasToken(token !== null);
    if (onChange !== undefined) {
      onChange(token);
    }
  }

  return (
    <div className={root}>
      <label className="apic-ui-token-bar-label" htmlFor="apic-ui-token-input">
        {"Bearer token"}
      </label>
      <input
        id="apic-ui-token-input"
        type="password"
        className={
          "apic-ui-token-bar-input" +
          (hasToken ? " apic-ui-token-bar-input--set" : "")
        }
        placeholder={"Paste token to authenticate"}
        autoComplete={"off"}
        onChange={handleChange}
      />
      {hasToken && (
        <span className="apic-ui-token-bar-status apic-ui-token-bar-status--set">
          {"Token set"}
        </span>
      )}
    </div>
  );
}
